import { SelectionOverride } from 'src/common-ui/components/Filters/Filters';
import { Scope } from 'src/types/Scope';

export interface AgentConversation {
  convoId: string;
  messages: AgentChatMessage[];
}

export enum AgentActionType {
  scopeRefresh = 'scopeRefresh',
  filterRefresh = 'filterRefresh',
  requestApproval = 'requestApproval',
  navigate = 'navigate',
  processing = 'processing',
}

export interface AgentActionScopeRefresh {
  type: AgentActionType.scopeRefresh;
  params?: Scope;
}

export interface AgentActionFilterRefresh {
  type: AgentActionType.filterRefresh;
  params?: SelectionOverride[];
}

export interface AgentActionRequestApproval {
  type: AgentActionType.requestApproval;
  params?: {
    requestedToolApproval: AgentActiveTool;
  };
}

export interface AgentActionNavigate {
  type: AgentActionType.navigate;
  params?: {
    url: string;
  };
}

export interface AgentActionProcessing {
  type: AgentActionType.processing;
  params?: {
    processingMessage: string;
  };
}

export type AgentAction =
  | AgentActionScopeRefresh
  | AgentActionFilterRefresh
  | AgentActionRequestApproval
  | AgentActionNavigate
  | AgentActionProcessing;

export enum AgentChatMessageType {
  user = 'user',
  agent = 'agent',
}

export enum AgentActiveTool {
  scopeUpdate = 'SCOPE_UPDATE_TOOL',
  filterUpdate = 'FILTER_UPDATE_TOOL',
  navigate = 'NAVIGATE_TOOL',
}

export interface AgentChatMessage {
  user: string;
  type: AgentChatMessageType;
  convoId: string;
  activeTool?: AgentActiveTool;
  message?: string;
  actions: AgentAction[];
}
